import React, { useEffect, useState } from "react";
import NavHeader from "../components/NavHeader";
import { AdminUser } from "../const/types";
import ComponentSpinner from "../components/ComponentSpinner";
import cr from "../lib/request";
import {
  HStack,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
  VStack,
} from "@chakra-ui/react";
import { MagnifyingGlass } from "@phosphor-icons/react";
import AdminCard from "../components/accountComponents/AdminCard";
import TambahAdminAccount from "../components/accountComponents/TambahAdminAccount";
import useTrigger from "../globalState/useTrigger";
import UpdateAccountModal from "../components/accountComponents/UpdateAccountModal";
import SwitchAdminAccountStatus from "../components/accountComponents/SwitchAdminAccountStatus";
import DeleteAdminAccountModal from "../components/accountComponents/DeleteAdminAccountModal";
import { Cookies } from "typescript-cookie";

export default function Account() {
  const [data, setData] = useState<AdminUser[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");
  const { trigger } = useTrigger();
  const userCookie = Cookies.get("user");
  const user = JSON.parse(userCookie as string);

  useEffect(() => {
    setLoading(true);
    const url = `api/account/alladminaccount`;
    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [trigger]);

  return (
    <>
      <NavHeader label="Akun Admin" />

      {loading && <ComponentSpinner flex={1} />}

      {!loading && data && data.length > 0 && (
        <VStack align={"stretch"} p={5}>
          <HStack justify={"space-between"} mb={4}>
            <InputGroup>
              <InputLeftElement>
                <Icon as={MagnifyingGlass} />
              </InputLeftElement>
              <Input
                maxW={"400px"}
                placeholder="Pencarian"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                value={search}
              />
            </InputGroup>

            <TambahAdminAccount />
          </HStack>

          <SimpleGrid columns={[1, null, 2, null, 3, 4]} gap={4} spacingY={6}>
            {data.map((admin, i) => {
              const searchTerm = search.toLowerCase();
              const ok =
                admin.id.toString().includes(searchTerm) ||
                admin.name.toLowerCase().includes(searchTerm) ||
                admin.username.toLowerCase().includes(searchTerm) ||
                admin.email.toLocaleLowerCase().includes(searchTerm);

              return (
                ok && (
                  <VStack
                    key={i}
                    align={"stretch"}
                    borderRadius={12}
                    p={2}
                    transition={"200ms"}
                    gap={0}
                    w={"100%"}
                    maxW={"400px"}
                    mx={"auto"}
                  >
                    <AdminCard data={admin} />

                    <VStack align={"stretch"} mt={4} gap={0}>
                      {/* <Text fontWeight={600} fontSize={20} lineHeight={1.4}>
                        {admin.name}
                      </Text>

                      <Text opacity={0.5} mb={4}>
                        {admin.username}
                      </Text> */}

                      <HStack justify={"space-between"}>
                        <HStack>
                          {user.id === 1 ||
                          (user.id !== 1 && admin.id !== 1) ? (
                            <UpdateAccountModal data={admin} />
                          ) : null}

                          {admin.id !== 1 && (
                            <SwitchAdminAccountStatus id={admin.id} />
                          )}
                        </HStack>

                        {admin.id !== 1 && (
                          <DeleteAdminAccountModal data={admin} />
                        )}
                      </HStack>
                    </VStack>
                  </VStack>
                )
              );
            })}
          </SimpleGrid>
        </VStack>
      )}
    </>
  );
}
